import Vue from 'vue'

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * Quotation requisition approve
 *
 * @param  {object}
 */

const quotationApprove = (payload, needsAuth) => {
  if (needsAuth) {
    return Vue.$http.put(`purchase/quotation/authorize/${payload.quotation}/`, { authorized: true })
      .then()
      .catch(error => { throw error })
  } else {
    return Vue.$http.put(`purchase/quotation/approve/${payload.quotation}/`)
      .then()
      .catch(err => {
        throw err
      })
  }
}

export default quotationApprove


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/quotationApprove.js